// false quando o navegador não deixa (fora de HTTPS/localhost ou permissão negada): a tela mostra o link para copiar à mão.
export const copyText = async (text) => {
  try {
    if (!navigator.clipboard || typeof navigator.clipboard.writeText !== "function") return false;
    await navigator.clipboard.writeText(text);
    return true;
  } catch (e) {
    return false;
  }
};
